export const decimal = function (v, scale = 2) {
  return parseFloat(parseFloat(v).toFixed(scale))
}